import React, { useContext } from 'react';
import { Context as ConfigContext } from '../Config';
import usePageClassName from '../hooks/usePageClassName';
import useHomePageData from '../hooks/useHomePageData';
import useTranslation from '../hooks/useTranslation';
// import HomeSchema from '../toolkit/HomeSchema';
import WithTitle from '../components/WithTitle';
import { HomeContext } from '../contexts';
import ErrorPage from './error';
import Error401Page from './error401';
const HomePage = ({}) => {
    const { t } = useTranslation();
    usePageClassName('index-page');
    const { fetchingStatus, data } = useHomePageData();
    const { pages, pageLoadingIndicator: Loader } = useContext(ConfigContext);
    if (fetchingStatus === 'is-fetching' ||
        fetchingStatus === 'not-started'
    // || fetchingStatus === 'NotAllowedError'
    )
        return React.createElement(Loader, null);
    if (fetchingStatus === 'LoginRequired')
        return React.createElement(Error401Page, null);
    if (fetchingStatus !== 'has-fetched' || !data)
        return React.createElement(ErrorPage, null);
    const title = t('pageTitles.home');
    const Page = pages.home.component;
    return (React.createElement(HomeContext.Provider, { value: data },
        React.createElement(React.Fragment, null,
            React.createElement(WithTitle, { title: title },
                React.createElement(Page, { homeData: data })))));
};
HomePage.displayName = 'HomePage';
export default HomePage;
//# sourceMappingURL=home.js.map